import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconCommunity(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M15.024 6.979 9.746 1.646a1.05 1.05 0 0 0-1.492 0L2.976 6.979a1.06 1.06 0 0 0-.309.754v6.4c0 .142.056.278.155.378s.233.156.373.156h4.222c.14 0 .274-.056.373-.156a.54.54 0 0 0 .155-.378V10.4h2.11v3.733a.53.53 0 0 0 .529.534h4.222c.14 0 .274-.056.373-.156a.54.54 0 0 0 .155-.378v-6.4a1.07 1.07 0 0 0-.31-.754m-.746 6.621h-3.167V9.867a.54.54 0 0 0-.154-.377.53.53 0 0 0-.373-.157H7.417a.53.53 0 0 0-.373.157.54.54 0 0 0-.155.377V13.6H3.723V7.733L9 2.4l5.278 5.333z"
      />
      <path
        fill="currentColor"
        d="M4.55 2a.78.78 0 0 1 .548.225l1.569 1.593-.706.727L4.55 3.091 1.726 6v2.99h1.059V10H1.133a.47.47 0 0 1-.33-.135.46.46 0 0 1-.136-.327V5.846a.76.76 0 0 1 .228-.544L4 2.225A.78.78 0 0 1 4.55 2"
      />
    </SVGIcon>
  );
}
